/**
 * CW_008 (2026-07-30 T073 追加バグ = 山内さま指摘):
 *   商品カード slider-button スライド中 (smooth scroll 進行中) 連続クリック =
 *   Dawn slider-component onButtonClick が scrollLeft 中間値を基準に 次位置計算 = 画像 擦れ発生
 *
 * 対策: 400ms throttle = capture phase で Dawn handler より先に intercept =
 *   throttle 中の click = stopImmediatePropagation で Dawn handler 発火阻止
 *
 * 対象: .c-product-card__slider-button (image_display_mode = slider 時 Chevron prev/next)
 */
(function () {
  const THROTTLE_MS = 400;

  document.addEventListener(
    'click',
    function (evt) {
      const btn = evt.target.closest('.c-product-card__slider-button');
      if (!btn) return;

      if (btn.dataset.cSliderThrottling === 'true') {
        // Throttle 中 = Dawn handler 発火阻止 + navigation 阻止
        evt.stopImmediatePropagation();
        evt.preventDefault();
        return;
      }

      btn.dataset.cSliderThrottling = 'true';
      setTimeout(() => {
        delete btn.dataset.cSliderThrottling;
      }, THROTTLE_MS);
    },
    true // capture phase = Dawn handler より 先に fire
  );
})();
